import React from 'react';
import Header from '../Components/Header';
import Section from '../Components/Section';
import Footer from '../Components/Footer';
import Moon from '../Components/Moon';
export default function Home() {
  return <>
    <Header/>
    <Moon/>
    <Section/>
    <Footer/>
    </>;
}
